<template>
<div style="display:inline-block;margin-left:15px;margin-top:15px">
    <transition-group name="fade">
        <img style="margin-left:-15px;margin-top:-15px" class="round white-border shadow" :width="size" :height="size" v-for="(path) in images" :src="path" alt="" :key="path"/>
    </transition-group>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        images: Array,
        size: {
            type: Number,
            default: 50,
        }
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// ImageGroup.vue?2d96dc19